// removed by extract-text-webpack-plugin
module.exports = {"edit-role-form-wrapper":"edit-role-form-wrapper","editRoleFormWrapper":"edit-role-form-wrapper","edit-role-buttons-container":"edit-role-buttons-container","editRoleButtonsContainer":"edit-role-buttons-container"};


//////////////////
// WEBPACK FOOTER
// ./src/components/roles/editRole/form/style.scss
// module id = 1635
// module chunks = 0